import { Component, OnInit,ViewChild } from '@angular/core';
import { QuotationService} from 'app/shared/services/quotation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-quotation-list',
  templateUrl: './quotation-list.component.html',
  styleUrls: ['./quotation-list.component.css']
})
export class QuotationListComponent implements OnInit {

  displayedColumns: string[] = ['quotationNo', 'quotationDate', 'customer', 'amount','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  quotation : any [] =[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  constructor(
              private quotationService : QuotationService, 
              private router : Router, 
              private route : ActivatedRoute, 
              private themeService: NbThemeService,
              private authService: AuthService,
             ) { }

  ngOnInit() {

    this.getAllQuotation();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
     
    
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='QUO'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }
  

    newButtonClick(){
    this.router.navigate(['../quotation'],{relativeTo : this.route});
    }


    getAllQuotation(){
    this.quotationService.getAll()
     .subscribe(
        (data) => {
                    this.quotation = data;
                    this.dataSource = new  MatTableDataSource (this.quotation);  
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;      
                   
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }
   

     viewDetailsButtonClick(quotationNo : string){   
        this.router.navigate(['../quotation'],{queryParams : {'quotationNo':quotationNo},relativeTo : this.route});            
     }



   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }

}
